import type { ReactNode } from 'react';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';

// Prose primitives for the legal documents. Deliberately dumb — the documents
// are the content, these just carry the type scale.

export const P = ({
  children
}: {
  children: ReactNode;
}) => <p {...stylex.props(styles.paragraph)}>{children}</p>;
export const H3 = ({
  children
}: {
  children: ReactNode;
}) => <h3 {...stylex.props(styles.subheading)}>{children}</h3>;
export const Ul = ({
  items
}: {
  items: ReactNode[];
}) => <ul {...stylex.props(styles.list)}>
    {items.map((item, i) => <li key={i} {...stylex.props(styles.listItem)}>{item}</li>)}
  </ul>;
export const Callout = ({
  children
}: {
  children: ReactNode;
}) => <div {...stylex.props(styles.callout)}>{children}</div>;
export const Ext = ({
  href,
  children
}: {
  href: string;
  children: ReactNode;
}) => <a href={href} target="_blank" rel="noreferrer" {...stylex.props(styles.link)}>
    {children}
  </a>;
export const Table = ({
  head,
  rows
}: {
  head: string[];
  rows: ReactNode[][];
}) => <div {...stylex.props(styles.tableScroll)}>
    <table {...stylex.props(styles.table)}>
      <thead>
        <tr>
          {head.map(h => <th key={h} scope="col" {...stylex.props(styles.th)}>{h}</th>)}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, i) => <tr key={i}>
            {row.map((cell, j) => <td key={j} {...stylex.props(styles.td)}>{cell}</td>)}
          </tr>)}
      </tbody>
    </table>
  </div>;

// Highlights an unreplaced [[TOKEN]] from entity.ts so it cannot ship unnoticed.
export const Tok = ({
  value
}: {
  value: string;
}) => value.includes('[[') ? <span {...stylex.props(styles.todo)}>{value}</span> : <>{value}</>;